import { CloudProvider } from '../types';
import { DomainSuffix } from './constants';

// Returns the current TIER's domain suffix
export const getDomainSuffix = (): DomainSuffix => {
  let domainSuffix = DomainSuffix.PRD;
  const browserURL = window.location.host.toLowerCase();
  if (browserURL.indexOf(DomainSuffix.DEV) > -1 || browserURL.indexOf('localhost') > -1) {
    domainSuffix = DomainSuffix.DEV;
  } else if (browserURL.indexOf(DomainSuffix.STG) > -1) {
    domainSuffix = DomainSuffix.STG;
  }
  return domainSuffix;
};

export const getCMPLink = (ceDomain: string, cloudProvider: CloudProvider, route = ''): string => {
  const browserURL = window.location.host.toLowerCase();
  if (browserURL.indexOf('localhost') > -1) return 'http://localhost:3000';
  return cloudProvider === CloudProvider.AZURE
    ? `https://${ceDomain}/portal/#/${route}`
    : `https://portal.${ceDomain}/#/${route}`;
};

export const getTaniumConsoleLink = (ceDomain: string): string => {
  return `https://${ceDomain}`;
};

export const getArtifactsLink = (): string => {
  const browserURL = window.location.host.toLowerCase();
  if (browserURL.indexOf('localhost') > -1) return 'http://localhost:3000';
  const domainSuffix = getDomainSuffix();
  return `https://artifacts${domainSuffix}`;
};
